import { toSize } from './utils'

export const spaces = {
    size: {
        space24: toSize([48, 36]),
        space14: toSize([48, 36]),
        space10: toSize([5]),
    },
}
